import React, { useState } from 'react';
import PieChart from './PieChart';
import { EmptyState } from '@/components/custom/empty-state';
import { FiChevronDown } from 'react-icons/fi';

export default function PieChartWidget({ data = [], filters }) {
  const [sortDirection, setSortDirection] = useState('desc');

  const sorted = [...data].sort((a, b) => {
    if (sortDirection === 'asc') {
      return a['accesses'] - b['accesses'];
    } else {
      return b['accesses'] - a['accesses'];
    }
  });

  return (
    <>
      {/* Mostra estado vazio se não vier dados ou se todos os valores forem zero */}
      {data.length === 0 || data.every(item => item['accesses'] === 0) ? (
        <EmptyState
          type="data"
          text="Não há dados para exibir no gráfico."
          className="my-10"
        />
      ) : (
        <div className="report-widget">
          <div className="report-widget__header">
            <div className="report-widget__inner">
              <h3 className="report-widget__title">Cadastro nas GRE's</h3>
            </div>
            <button
              className="btn btn--outline"
              disabled={data.length === 0}
              onClick={() => setSortDirection(sortDirection === 'desc' ? 'asc' : 'desc')}
            >
              {' '}
              <FiChevronDown
                className="h-6 w-6"
                style={{ transform: sortDirection === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
              />
              Ordenar pelo {sortDirection === 'desc' ? 'menor' : 'maior'}
            </button>
          </div>

          <div className="report-widget__body">
            <PieChart
              data={sorted}
              filters={filters}
            />
          </div>
        </div>
      )}
    </>
  );
}
